<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import SalesDetailSaleCommissionSummary from './SalesDetailSaleCommissionSummary.vue';
import SalesDetailSalePartiesSummary from './SalesDetailSalePartiesSummary.vue';
import SalesDetailSalePropertySummary from './SalesDetailSalePropertySummary.vue';

defineProps({ transaction: { type: Object, required: true } });
const { t } = useI18n();
</script>

<template>
  <div class="grid gap-4">
    <SalesDetailSalePropertySummary :transaction="transaction" />
    <SalesDetailSalePartiesSummary :parties="transaction.party_details || []" />
    <SalesDetailSaleCommissionSummary :transaction="transaction" />
    <LaisCard
      :title="t('SALES.DETAIL.SALE_SUMMARY.OBSERVATIONS')"
      prefix-icon="i-lucide-message-square-text"
    >
      <p
        class="whitespace-pre-wrap text-sm leading-relaxed text-lais-text-body"
      >
        {{ transaction.profile?.observacao || t('SALES.DETAIL.EMPTY_VALUE') }}
      </p>
    </LaisCard>
  </div>
</template>
